import {gql} from "@irati/utils/gql"

const fullMetadataFragment = gql`
  fragment fullMetadata on Metadata {
    createdAt
    createdBy
    updatedAt
    updatedBy
  }
`

const dealBrandFragment = gql`
  fragment dealBrand on DealBrand {
    uuid
    name
    domain
    description
    logoUrl
    bannerUrl
    approved
    label
    parentId
    parent {
      uuid
      name
      domain
      description
      logoUrl
      bannerUrl
      label
      status
    }
    dateUnix
    slug
    status
    variants @include(if: $withVariants) {
      uuid
      name
      domain
      description
    }
    tags {
      kind
      name
      url
      uuid
    }
    metadata {
      ...fullMetadata
    }
  }

  ${fullMetadataFragment}
`

export default dealBrandFragment
